import { useMemo } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { fileTypeAccess } from "@hightouch/lib/llm/files/feature-access";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";
import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";

export function useFileTypeAccess() {
  const { appAmpV2, ampWebPagesEnabled } = useFlags();
  const ads = useIsAdStudioEnabled();
  const lcm = useLifecycleStudioEnabled();
  return useMemo(
    () =>
      fileTypeAccess({
        amp: Boolean(appAmpV2),
        ads,
        lcm,
        webPages: Boolean(ampWebPagesEnabled),
      }),
    [appAmpV2, ads, lcm, ampWebPagesEnabled],
  );
}
